import * as React from "react"
export const Svg_047 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="m51.97 46.733-2.402 2.445 1.926 1.96H30.7v-3.519c9.072-.873 16.193-8.666 16.193-18.119S39.772 12.254 30.7 11.381V4.405H6.506l1.926-1.96L6.03.002 0 6.134l6.03 6.133 2.402-2.445-1.926-1.96H27.3v3.519c-9.072.873-16.193 8.666-16.193 18.119s7.12 17.246 16.193 18.12v6.975h24.193l-1.926 1.96 2.403 2.444L58 52.866l-6.03-6.133ZM23.178 33.492h3.398c0 .744.596 1.35 1.328 1.35h1.746c.98 0 1.776-.81 1.776-1.806 0-.997-.797-1.807-1.776-1.807H28.35c-2.853 0-5.174-2.362-5.174-5.264 0-2.537 1.772-4.66 4.124-5.155V18.5h3.398v2.24c2.323.301 4.124 2.325 4.124 4.769h-3.398c0-.745-.596-1.351-1.328-1.351h-1.746c-.98 0-1.776.81-1.776 1.807 0 .996.797 1.806 1.776 1.806h1.297c2.854 0 5.175 2.362 5.175 5.265 0 2.536-1.772 4.66-4.124 5.155V40.5h-3.398v-2.24c-2.323-.301-4.124-2.325-4.124-4.768Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={13.412}
        x2={41.648}
        y1={8.851}
        y2={53.775}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v59H0z" />
      </clipPath>
    </defs>
  </svg>
)